var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('img',{staticClass:"bg-download",attrs:{"src":_vm.downloadImg,"alt":"app下载"}}),_c('img',{staticClass:"qr-code",attrs:{"src":_vm.qrCode,"alt":"app下载"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }